import type {
  PrivacyScriptConfig,
} from "../types";




export function loadScript(
  script: PrivacyScriptConfig
){



  const existing =
    document.getElementById(
      script.id
    );



  if(existing){

    return;

  }



  const element =
    document.createElement(
      "script"
    );



  element.id =
    script.id;



  if(script.src){


    element.src =
      script.src;


    element.async =
      true;


  }



  if(script.code){


    element.text =
      script.code;


  }



  document.body.appendChild(
    element
  );


}





export function removeScript(
  id:string
){


  const script =
    document.getElementById(
      id
    );



  if(script){

    script.remove();

  }


}